import { ColumnsType } from 'antd/es/table';
import { BroadCast, getFieldName } from 'src/models/broadCast';
import { dateToYMdhm } from 'src/util';

export const normalColumns: ColumnsType<BroadCast> = [
  {
    title: '配信状況',
    dataIndex: getFieldName('statusInJp'),
    key: getFieldName('statusInJp'),
  },
  {
    title: '配信時刻',
    dataIndex: getFieldName('sendAt'),
    key: getFieldName('sendAt'),
    render(v: Date | null) {
      if (v === null) {
        return '-';
      }
      return dateToYMdhm(v);
    },
  },
  {
    title: 'タイトル',
    dataIndex: getFieldName('title'),
    key: getFieldName('title'),
  },
  {
    title: '配信対象',
    dataIndex: getFieldName('sendMCustomerLineIds'),
    key: getFieldName('sendMCustomerLineIds'),
    render(v: string[] | null) {
      if (v === null || v.length === 0) {
        return '全員';
      } else {
        return 'ファイルアップロード';
      }
    },
  },
];

export const formatSegmentConditions = (conditions: any): string => {
  if (!conditions) return '-';
  
  const parts: string[] = [];

  if (conditions.specificDateVisit) {
    parts.push('特定日来店');
  }

  if (conditions.visitPattern) {
    parts.push('来店パターン');
  }

  if (conditions.customerRank) {
    parts.push('顧客ランク');
  }
  
  if (conditions.itemPreferences) {
    parts.push('商品購入');
  }
  
  if (conditions.pointCard) {
    parts.push('ポイントカード');
  }
  
  if (conditions.surveyAnswers) {
    parts.push('アンケート');
  }
  
  return parts.length > 0 ? parts.join('、') : '-';
};

export const getSegmentStatus = (broadcast: BroadCast): string => {
  const { segmentJobStatus, status } = broadcast;

  // segmentJobStatusがnullの場合
  if (segmentJobStatus === null) {
    if (status === 'draft') {
      return '下書き';
    }
  }
  
  // segmentJobStatusがprocessingの場合
  if (segmentJobStatus === 'processing') {
    return '集計中';
  }

  // segmentJobStatusがerrorの場合
  if (segmentJobStatus === 'error') {
    return '配信先検索エラー';
  }
  
  // segmentJobStatusがcompletedの場合
  if (segmentJobStatus === 'completed') {
    switch (status) {
      case 'draft':
        return '集計済み';
      case 'reserved':
        return '予約済み';
      case 'sent':
        return '配信済み';
      default:
        return status;
    }
  }
  
  // その他の場合
  return status;
};

export const segmentColumns: ColumnsType<BroadCast> = [
  {
    title: '処理状況',
    key: 'segmentStatus',
    width: 150,
    render: (_, record) => getSegmentStatus(record),
  },
  {
    title: '配信時刻',
    dataIndex: getFieldName('sendAt'),
    key: getFieldName('sendAt'),
    width: 480,
    render(v: Date | null) {
      if (v === null) {
        return '-';
      }
      return dateToYMdhm(v);
    },
  },
  {
    title: 'タイトル',
    dataIndex: getFieldName('title'),
    key: getFieldName('title'),
    width: 580,
    ellipsis: true,
  },
  {
    title: '設定セグメント',
    key: 'segmentConditions',
    ellipsis: true,
    render: (_, record) => formatSegmentConditions(record.segmentConditions),
  },
];
